import { Flex, Grid, Heading, Stack } from '@chakra-ui/react'
import * as React from 'react'
import FadeInUpBox from '../components/fade-in-up-box'
import ProjectCard, { ProjectCardProps } from '../components/project-card'

function Projects() {
  const projects: ProjectCardProps[] = [
    {
      name: 'Quizli',
      url: 'https://quizli.fr/',
      description:
        'A general knowledge quiz platform designed to help you learn and improve — play quizzes, learn from your mistakes, and track your progress over time.',
      skills: ['Next.js', 'NestJS', 'PostgreSQL'],
    },
    {
      name: 'Tensiomètre Locatif',
      url: 'https://www.tensiometre-locatif-map.fr/',
      description:
        'An interactive map of France showing rental market tension by city and housing type — balancing supply and demand against tenant budgets. Data sourced from locservice.fr.',
      skills: ['Next.js', 'NestJS', 'PostgreSQL'],
    },
  ]

  return (
    <Grid minH="100vh" p={3}>
      <Stack
        justifyContent="space-around"
        alignSelf="center"
        direction={['column', 'column', 'column', 'row']}
        p={[4, 6, 10, 15, 40]}
      >
        <Flex className="max-w-screen-md" direction="column" justifyContent="center" p={[0, 0, 0, 10]}>
          <FadeInUpBox yOffset={64} duration={1}>
            <Heading className="mb-4" as="h2" size="3xl">
              Projects
            </Heading>
          </FadeInUpBox>

          <Flex gap={2} wrap="wrap">
            {projects.map((project, index) => (
              <Flex key={project.name} basis={['100%', '100%', '100%', '45%']}>
                <FadeInUpBox yOffset={64} duration={0.5} delayOrder={2 + index * 0.5}>
                  <ProjectCard
                    name={project.name}
                    url={project.url}
                    description={project.description}
                    skills={project.skills}
                  />
                </FadeInUpBox>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Stack>
    </Grid>
  )
}

export default Projects
